import React, { useState } from 'react';
import { Button, message, Spin, Space, Card, Statistic } from 'antd';
import { LoginOutlined, LogoutOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { markAttendance } from '../redux/slices/attendanceSlice';
import attendanceService from '../services/attendanceService';

const AttendanceMarker = () => {
  const dispatch = useDispatch();
  const { isLoading, currentStatus } = useSelector(state => state.attendance);
  const [checkInTime, setCheckInTime] = useState(null);

  const handleMarkAttendance = async (type) => {
    try {
      const location = await attendanceService.getCurrentLocation();
      
      const result = await dispatch(markAttendance({
        latitude: location.latitude,
        longitude: location.longitude,
        attendanceType: type
      })).unwrap();

      if (type === 'check-in') {
        setCheckInTime(new Date());
        message.success('Check-in successful');
      } else {
        message.success('Check-out successful');
      }
    } catch (error) {
      message.error(error || 'Failed to mark attendance');
    }
  };

  return (
    <Card>
      <div style={{ textAlign: 'center' }}>
        <h2>Mark Attendance</h2>
        
        {currentStatus && (
          <Statistic
            title="Current Status"
            value={currentStatus.status}
            valueStyle={{
              color: currentStatus.status === 'Present' ? '#52c41a' : '#f5222d'
            }}
          />
        )}

        {checkInTime && (
          <Statistic
            title="Check-in Time"
            value={checkInTime.toLocaleTimeString()}
            style={{ marginTop: 20 }}
          />
        )}

        <Space style={{ marginTop: 20 }}>
          <Spin spinning={isLoading}>
            <Button
              type="primary"
              icon={<LoginOutlined />}
              size="large"
              onClick={() => handleMarkAttendance('check-in')}
              loading={isLoading}
            >
              Check In
            </Button>
            <Button
              type="default"
              icon={<LogoutOutlined />}
              size="large"
              onClick={() => handleMarkAttendance('check-out')}
              loading={isLoading}
            >
              Check Out
            </Button>
          </Spin>
        </Space>
      </div>
    </Card>
  );
};

export default AttendanceMarker;
